var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,{tag:"component",class:_vm.iconClass}):_c('span',{class:_vm.iconClass})}
var staticRenderFns = []

export { render, staticRenderFns }